import styled from 'styled-components'

export const DownloadCalendarBtnWrapper = styled.div`
  ${({ theme }) => `
    button {
      height: 100%;

      &.hasChanges {
        border: 1px solid orange;
      }

      &.warning {
        color: ${theme.palette.white};
      }
    }
  `}
`

export const ModalIconWrapper = styled.div`
  ${({ theme }) => `
    margin-bottom: -${theme.space.md};

    svg {
      font-size: 44px;
    }
  `}
`

export const ModalDownloadCalWrapper = styled.div`
  ${({ theme }) => `
    text-align: center;

    &.info {
      margin-bottom: -${theme.space.xl};
    }

    button {
      padding: 12px ${theme.space.sm} !important;
      margin-left: ${theme.space.xxs};
      margin-right: ${theme.space.xxs};
    }
  `}
`

export const StyledH2 = styled.h2`
  ${({ theme }) => `
    font-size: ${theme.fontSize.lg};
    font-weight: ${theme.fontWeight.bold};
  `}
`
